import { ERC20_ABI } from '@/abi'

type ReceiptClient = {
  waitForTransactionReceipt: (args: { hash: `0x${string}`; timeout: number }) => Promise<unknown>
}

type ApproveWriter = (args: {
  address: `0x${string}`
  abi: typeof ERC20_ABI
  functionName: 'approve'
  args: [`0x${string}`, bigint]
}) => Promise<`0x${string}`>

interface EnsureExactErc20AllowanceParams {
  tokenAddress: `0x${string}`
  spender: `0x${string}`
  currentAllowance: bigint
  requiredAllowance: bigint
  viemClient: ReceiptClient
  writeContractAsync: ApproveWriter
  timeout?: number
}

export async function ensureExactErc20Allowance({
  tokenAddress,
  spender,
  currentAllowance,
  requiredAllowance,
  viemClient,
  writeContractAsync,
  timeout = 60_000,
}: EnsureExactErc20AllowanceParams): Promise<boolean> {
  if (requiredAllowance <= 0n || currentAllowance >= requiredAllowance) {
    return false
  }

  if (currentAllowance > 0n) {
    const resetHash = await writeContractAsync({
      address: tokenAddress,
      abi: ERC20_ABI,
      functionName: 'approve',
      args: [spender, 0n],
    })
    await viemClient.waitForTransactionReceipt({ hash: resetHash, timeout })
  }

  const approveHash = await writeContractAsync({
    address: tokenAddress,
    abi: ERC20_ABI,
    functionName: 'approve',
    args: [spender, requiredAllowance],
  })
  await viemClient.waitForTransactionReceipt({ hash: approveHash, timeout })

  return true
}